<template>
    <div id="app">
        <managerComponent/>
        <tagsDialog/>
        <dataDialog/>
        <fvTextExtend/>
        <noWindow/>
        <login/>
        <loginTaishanSteel/>
        <loginApp/>
        <tooltip/>
        <contextMenu/>
        <webmaster/>
        <alarmCenter/>
        <userRegister/>
        <alarmIdsShow/>
        <dragResize/>
        <historyPlaybackControl/>
        <screencap/>
        <div v-if="isShowLineProgress" style="position:absolute;left:5%;bottom:100px;width:90%;z-index:999999">
            <div style="font-size:20px">{{showTitle}}</div><br>
            <Progress :percent="loadProgress" status="active" :stroke-width="strokeWidth" hide-info></Progress>
            <div style="color:#FF0000">{{tips}}</div><br>
        </div>
        <div v-if="isShowProgress" style="z-index:999999">
             <Spin fix>
                <Icon type="ios-loading" size=100 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
        </div>
    </div>
</template>

<script>
import version from './version.js';
import axios from 'axios'
import Vue from 'vue';
import fvScript from "./js/script/fvScript.js";
import db from './js/communication/dbCommunicate.js';
import backstageClass from './js/backstage';
import { setTimeout } from 'timers';
export default {
    name: 'App',
    created :function(){
        this.$store.registerModule(["system"],{
            state : {
                $ : this
            }
        });
        this.strokeWidth = window.isApp() ? 10 : 30;
        window.devicePixelRatio = 1
        if(window.isApp()){
            window.devicePixelRatio = 2;
        }
        console.log(version);
        window.version = version;
        Vue.prototype.fvScript = new fvScript(this.$store.state.system);
        document.onmousewheel = this.onMouseScroll.bind(this);
        //绑定触发中心与鼠标对其的鼠标位置
        document.onmouseup = this.onmouseup.bind(this);
        document.onmousedown = this.onmousedown.bind(this);
        document.onmousemove = this.onmousemoves.bind(this);
        if(window.isApp()){//判断是否是手机
            //监听手机的事件
            //手指按下事件true
            document.addEventListener('touchstart',this.touchstart.bind(this),true);
            //手指抬起事件
            document.addEventListener('touchend', this.touchend.bind(this),true);
            if(this.embedView){
                //手指拖动事件
                document.addEventListener('touchmove', this.touchmove.bind(this),{passive:false});
            }else{
                document.addEventListener('touchmove', this.touchmove.bind(this),{passive:false});
            }
        }
        
        this.run(); 
        
        
    },
    data :function() {
        return {
            indexDB:null,
            zoomList : {x:0,y:0},
            strokeWidth : 30,
            tips : "",
            isShowProgress : true,
            showTitle : "",
            isShowLineProgress:false,
            loadProgress : 10,
            scaleNum : 100,
            timeStamp : 0,
            //系统配置信息rootconfig
            jsonSysRootConfig : {},
            //系统初始化完毕标记为
            lastRealValueTime  :  0,
            lastUiRefreshTime : 0,
            alarmTagList  :  [],
            textInvalid  :  "?",
            //初始启动时间
            initialTime : Date.now(),
            isShowBar : false,
            dbCom : db,
            isInitComplate : false,
            isInitComplateTwo :false,
            userName : "",
            imgs : {},
            startWindows : {},//初始启动窗口。由url中的参数或者默认启动窗口构造
            isUrlWindow : false,//标示url中是否设置了启动窗口
            appWinTitleHeight : 32, //固定值
            appWinSysHeight : 40,//固定值
            ishasLanguage : false,
            languageName : "ch",
            resource : {},
            languageList : [],
            //用于记录是否放大缩小过
            isZoom:false,
            touchLeftX:0,
            touchLeftY:0,
            animationType : true,
            touchLength:0,
            lastMoveLength : 0,
            viewList:[],
            shortcutMenu:{},
            labelSys:{},
            cookieTokey:""
        }
    },
    methods : { 
        async isLocks(winName,param){
                var winData = null;
                var transaction = window.systemDBId.transaction(['projectObject']);
                var objectStore = transaction.objectStore('projectObject');
                
                var request = objectStore.getAll();
                // var request = objectStore.get(1);
                request.onsuccess = async function(event) {
                    if(request.result.length == 0){
                        this.createLocks();
                        this.indexDB = [{
                            id: 1,
                            isLocalCache: false,
                            isSvg: false,
                            tokey:"1",
                        }];
                    }else{
                        this.indexDB = request.result;
                    }
                }.bind(this);
        },
        // 获取 或 请求 存储的db的数据
        createLocks(winName,winData) {
            //如果表格不存在，创建一个新的表格（keyPath，主键 ； autoIncrement,是否自增），会返回一个对象（objectStore）
            // objectStore就相当于数据库中的一张表。IDBObjectStore类型。      
            var transaction = window.systemDBId.transaction(["projectObject"], 'readwrite');
            // 通过事务来获取IDBObjectStore
            var store = transaction.objectStore("projectObject");
            // 往store表中添加数据
            var addPersonRequest = store.add({
                "isSvg" : false,//是否启用svg
                "isLocalCache":false,//是否启用高速缓存
            });
            // 监听添加成功事件
            addPersonRequest.onsuccess = function(e) {
                console.log(e.target.result); // 打印添加成功数据的 主键（id）
            };

            // 监听失败事件
            addPersonRequest.onerror = function(e) {
                console.log(e.target.error);
            };
        },
         createWinDB (){
            //1\. 获取IDBFactory接口实例（文档地址： https://developer.mozilla.org/en-US/docs/Web/API/IDBFactory）
            var indexedDB =
            window.indexedDB ||
            window.webkitIndexedDB ||
            window.mozIndexedDB ||
            window.msIndexedDB;
            if (!indexedDB) {
                console.log('你的浏览器不支持IndexedDB');
            }
            // 2\. 通过IDBFactory接口的open方法打开一个indexedDB的数据库实例
            // 第一个参数： 数据库的名字，第二个参数：数据库的版本。返回值是一个：IDBRequest实例,此实例有onerror和onsuccess事件。
            var IDBOpenDBRequest = indexedDB.open(this.projectName, 1);
            // 3\. 对打开数据库的事件进行处理
            // 打开数据库成功后，自动调用onsuccess事件回调。
            IDBOpenDBRequest.onsuccess = function(e) {
                window.indexDBId = e.target.result;
                
            }.bind(this);

            // 打开数据库失败
            IDBOpenDBRequest.onerror = function(e) {
                console.log(e.currentTarget.error.message);
            }.bind(this);

            // 第一次打开成功后或者版本有变化自动执行以下事件：一般用于初始化数据库。
            IDBOpenDBRequest.onupgradeneeded = function(e) {
                if (!e.target.result.objectStoreNames.contains("projectObject")) {
                    //如果表格不存在，创建一个新的表格（keyPath，主键 ； autoIncrement,是否自增），会返回一个对象（objectStore）
                    // objectStore就相当于数据库中的一张表。IDBObjectStore类型。
                    var objectStore = e.target.result.createObjectStore("projectObject", {
                        keyPath: 'id',
                        autoIncrement: true
                    });
                    
                }
            };
        },
        /*
            参数：   tagsStruct ：获取历史数据报文
            返回值： Promise对象
            说明：获取历史数据
            在API中有此方法， 因在api中图元调用不到， 临时使用此方法
        */
        getHistory(tagsStruct){
            return new Promise((resolve,reject) => {
                this.$store.state.system.$.dbCom.sendMessage(tagsStruct,(err,result)=>{
                    if(err){
                        reject(err);
                    }else{
                        resolve(result);
                    }
                });
            })
        },
        /*获取统计值方法*/
        getHistoryStatisData(tagsStruct){
            return new Promise((resolve,reject) => {
                this.$store.state.system.$.dbCom.sendMessage(tagsStruct,(err,result)=>{
                    if(err){
                        reject(err);
                    }else{
                        resolve(result);
                    }
                });
            })
        },
        //获取用户名
        getUserName(){
            if(this.userName == ""){
                return "system";
            }else{
                return this.userName;
            }
        },
        
        getDistance(p1, p2) {
            var x = p2.pageX - p1.pageX,
            y = p2.pageY - p1.pageY;
            return Math.sqrt((x * x) + (y * y));
        },
        create(){
            
            this.tagsTreeData = [];
            document.oncontextmenu = function(e) { 
                this.$store.state.system.manager.$.showMenu = true;
                return false;
            }.bind(this)
        },

        updataProgress(num,title){
            this.loadProgress = num;
		    
            if(num == 100){
                setTimeout(()=>{
                    this.isShowProgress = false;
                },200);
                //打印指定窗口需要打开窗口有在调用打印
                setTimeout(()=>{
                    if (window.opener != null && !window.opener.closed) {
                        // window.print();
                        window.opener = null;
                    }
                },2000)
            }else{
                this.isShowProgress = true;
            }
            
        },

        //系统启动入口
        run() {
            this.createWinDB();
            this.create();
            //建立socket链接.并获取数据源点属性
            this.dbCom.connectDb(()=>{
                //this.updataProgress(20,"建立连接");
                this.start();
                //重写console.log
                // if(window.isApp()){
                //     window.console=(async function(origConsole){
                //         if(!window.console)
                //             console = {};
                //         return {
                //             log: function(){
                //                 if(this.ttokey){
                //                     await this.setDB(this.ttokey);
                //                     this.cookieTokey = this.ttokey;
                //                     var tokey = this.ttokey;
                //                 }else{
                //                     var tokey = await this.setDB();
                //                 }
                //                 axios.post(window.debugFWebView+"/mobile/log",{message: arguments[0],headers: {'X-Requested-With': 'XMLHttpRequest',tokey:tokey}}).then((result)=>{
                //                 }).catch((error)=> {
                //                     origConsole.info(error);
                //                 });
                //             },
                //             info : function(){
                //                 origConsole.info(arguments[0]);
                //             },
                //             warn : function(){
                //                 origConsole.warn(arguments[0]);
                //             },
                //             error : function(){
                //                 origConsole.error(arguments[0]);
                //             },
                //             time : function(){
                //                 origConsole.time(arguments[0]);
                //             },
                //             timeEnd : function(){
                //                 origConsole.timeEnd(arguments[0]);
                //             }
                //         };
                //     }(window.console));
                // } 
            });
        },
        start(){
            debug.log("开始获取数据源点属性 -> ok");
            axios.get(window.debugFWebView + "default.json").then((configure)=>{
                debug.log("获取到工程名称 -> " + configure.data.defaultProject);
                //获取某个工程的json数据
                this.projectName = configure.data.defaultProject;
                var arr = [
                    //加载语言资源文件
                    axios.get(window.debugFWebView + this.projectName + "/Resources.json"),
                    //加载工程资源文件
                    axios.get(window.debugFWebView + this.projectName+"/projectConf.json")
                ]
                this.$store.state.system.manager.$.setProject(this.projectName);
                    axios.all(arr).then(axios.spread((configure,projectConf)=>{
                    this.resource = configure.data;
                    if(this.ishasLanguage == false){
                        this.languageName = configure.data.default;
                    }else if(this.resource[this.languageName] == undefined){
                        this.languageName = configure.data.default;
                    }
                    if(this.languageName == "ch"){
                        this.tips = window.isApp() ? "" : "按下F11键显示效果更佳";
                        this.showTitle = "准备建立连接";
                    }else{
                        this.tips = window.isApp() ? "" : "Press F11 key to display better effect";
                        this.showTitle = "Ready to connect";
                    }
                    // pc下缩放提示
                    if(!window.isApp() && window.devicePixelRatio !== 1){
                        this.$Message.warning({
                            content: this.languageName == "ch"? '当前页面不是100%显示，可能电脑存在缩放或浏览器存在缩放，建议恢复100%显示标准！': "The current page is not 100% displayed. There may be zooming on the computer or browser. It is recommended to restore the 100% display standard!",
                            duration: 2
                        });
                    }
                    this.__callViewFunction("setLanguage",[this.languageName]);
                    for(var p in configure.data){
                        if(p != "default")
                            this.languageList.push(p);
                    }
                    //初始化工程
                    this.Initialization(projectConf);
                })).catch((errorResult)=>{
                    console.warn("未加载到语言资源文件");
                    //标记是否请求到 语言文件
                    this.isJsonNull = true;
                    //初始化工程
                    axios.get(window.debugFWebView + this.projectName+"/projectConf.json").then((projectConf)=>{
                        if(this.languageName == "ch"){
                            this.tips = window.isApp() ? "" : "按下F11键显示效果更佳";
                            this.showTitle = "准备建立连接";
                        }else{
                            this.tips = window.isApp() ? "" : "Press F11 key to display better effect";
                            this.showTitle = "Ready to connect";
                        }
                        // pc下缩放提示
                        if(!window.isApp() && window.devicePixelRatio !== 1){
                            this.$Message.warning({
                                content: this.languageName == "ch"? '当前页面不是100%显示，可能电脑存在缩放或浏览器存在缩放，建议恢复100%显示标准！': "The current page is not 100% displayed. There may be zooming on the computer or browser. It is recommended to restore the 100% display standard!",
                                duration: 2
                            });
                        }
                        this.Initialization(projectConf);
                    })
                });
            }).catch((errorResult)=>{
                this.toLogin();
                document.title = this.getResource("FWebView") || "FWebView";
            });
            this.$store.state.system.$.dbCom.socketClient.on('message', function(msg){
                switch(msg.head){
                    case "forceLogOut":
                        alert("管理员已经强制这个链接断开");
                        this.$store.state.system.$.LogOut();
                        location.reload();
                    break;
                }
                
            }.bind(this))
            
        },
        //设置存储tokey到indexdb
        async setDB(value){
            return new Promise((resolve,reject) => {
                var transaction = window.systemDBId.transaction(["projectObject"], 'readwrite');
                // 通过事务来获取IDBObjectStore
                var store = transaction.objectStore("projectObject");
                var request = store.get(1);
                request.onsuccess = async function(event) {
                    this.cookieTokey = request.result.tokey;
                    if(value){//存值
                        var addPersonRequest = store.put({
                                id: 1, 
                                isLocalCache: request.result.isLocalCache,
                                isOpenPlayback: request.result.isOpenPlayback,
                                isSvg: request.result.isSvg,
                                tokey:value
                            });
                            addPersonRequest.onsuccess = function (event) {
                                resolve(value)
                            };
                            addPersonRequest.onerror = function (event) {
                                console.log('数据更新失败');
                            }
                    }else{
                        if(value){
                            var addPersonRequest = store.put({
                                id: 1, 
                                isLocalCache: request.result.isLocalCache,
                                isOpenPlayback: request.result.isOpenPlayback,
                                isSvg: request.result.isSvg,
                                tokey:value
                            });
                            addPersonRequest.onsuccess = function (event) {
                                resolve(value)
                            };
                            addPersonRequest.onerror = function (event) {
                                console.log('数据更新失败');
                            }
                        }else{
                            resolve(request.result.tokey);
                        }
                    }
                }.bind(this);
            })
        },
        //初始化工程  参数：请求的josn数据
        async Initialization(projectConf){
            
            this.isLocks();
            //用于推出登录后，传递 登录框的位置
            this.projectConf = projectConf.data;
            debug.log("获取工程数据 -> ok");
            Object.assign(this,projectConf.data);
            debug.log("数据混淆 -> ok");
            var ssoLogin = this.getUrlParam();
            //判断是否是窗口以iframe打开窗口
            var isIframe = false;
            if(top!=self){//跨域无法获取到element 使用此写法
                var isIframe = true;
            }
            if(this.ishasLogin){
                if(ssoLogin){
                    //在url中解析到关键字，启动url登录
                    this.urlLogin(ssoLogin,async function(result){
                        if(result.data.err){
                            this.updataProgress(100,this.languageName == "ch"? "跳转到登录" :"Jump to login");
                            this.toLogin();
                            document.title = this.getResource("FWebView") || "FWebView";
                        }else{
                            //存储db---
                            await this.setDB(result.data.tokey);
                            // document.cookie = "name= " +result.data.tokey;
                            this.cookieTokey = result.data.tokey;
                            this.resultData = result.data;
                            this.userName = result.data.userName;
                             //用户级别
                            this.userLevel = result.data.userInfo.userLevel;
                            this.$store.state.system.$.dbCom.sendMessage({"head" : "getProperty"},function(err,message){
                                window["tagProprety"] = message;
                                this.routes({type:"SmartWorx"});
                            }.bind(this))
                        }
                    });
                }else{
                    //需要鉴权，请求是否已经登录
                    // var url = window.debugFWebView + "islogin?id=" + this.dbCom.getLinkId()+";tokey="+document.cookie.slice(5);
                    // //获取url中的参数。构造初始启动信息,返回是否在url中添加了登录信息
                    // var url = window.debugFWebView + "islogin?id=" + this.dbCom.getLinkId()+";tokey="+document.cookie.slice(5);
                    // //获取url中的参数。构造初始启动信息,返回是否在url中添加了登录信息

                    if(this.ttokey){
                        await this.setDB(this.ttokey);
                        this.cookieTokey = this.ttokey;
                        var tokey = this.ttokey;
                    }else{
                        var tokey = await this.setDB();
                    }
                    //获取url的打开窗口字符串
                    if(location.search.indexOf("?tokey")>-1){
                        var nameList = "";
                    }else{
                        var nameList = location.search.substring(1);
                    }
                    //浙江 （张夏添定制项目需要 单点登录需要 传送 打开窗口名称以及是否是嵌入到iframe窗口）
                    var url = window.debugFWebView + "islogin?id=" + this.dbCom.getLinkId()+"&start="+nameList+"&isIframe="+isIframe;
                    axios.get(url,
                        {
                            headers: {'X-Requested-With': 'XMLHttpRequest',tokey:tokey},
                            withCredentials:true
                        }).then(async(result)=>{
                        if(result.data.result){
                            await this.setDB(result.data.tokey)
                            // document.cookie = "name= " +result.data.tokey;
                            this.cookieTokey = result.data.tokey;
                            this.resultData = result.data;
                            //已经登录
                            this.userName = result.data.userName;
                            //用户级别
                            this.userLevel = result.data.userInfo.userLevel;
                            this.$store.state.system.$.dbCom.sendMessage({"head" : "getProperty"},function(err,message){
                                window["tagProprety"] = message;
                                this.routes({type:"SmartWorx"});
                            }.bind(this))
                        }else{
                            if(result.data.redirectURL){
                                window.location.href = result.data.redirectURL; 
                            }else{
                                this.updataProgress(100,this.languageName == "ch"? "跳转到登录" :"Jump to login");
                                this.toLogin();
                                document.title = this.getResource("FWebView") || "FWebView";
                            }
                        }
                    }).catch((error)=> {
                        this.updataProgress(100,this.languageName == "ch"? "跳转到登录" :"Jump to login");
                        this.$Message.error(error);
                        this.toLogin();
                        document.title = this.getResource("FWebView") || "FWebView";
                    });
                }
            }else{
                this.$store.state.system.$.dbCom.sendMessage({"head" : "getProperty"},function(err,message){
                    window["tagProprety"] = message;
                    this.routes({type:"SmartWorx"});
                }.bind(this))
                document.title = this.getResource("FWebView") || "FWebView";
            }
        },
        //获取cookie值
        getCookie(name){
            var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
            if(arr=document.cookie.match(reg))
                return unescape(arr[2]);
            else
                return null;
        },
        async urlLogin(data,callback){
            axios.post("/" + window.debugFWebView + "ssoLogin",{
                userName: data.userName,
                passWord: data.passWord,
                socketId : this.dbCom.getLinkId(),
                tokey:await this.setDB(),//this.getCookie("name")//取db---
                
            }).then(callback.bind(this)).catch(function (error) {
                this.$Message.error(error);
                console.log(error);
            });
        },
        initProject(){
            
            document.title = this.languageName == "ch"? "启动中" : "Starting";
            this.updataProgress(40,this.languageName == "ch"? "初始化工程信息" :"Initialize project information");
            this.$store.state.system.webmaster.$.show(false);
            this.$store.state.system.alarmCenter.$.show(false);
            
            //初始化数据源信息
            this.initDataSource();
            //初始化屏幕分辨率
            this.initScreenAdj();
            debug.log("初始化屏幕分辨率 -> ok");
            //注册程序动作脚本中用到的数据库变量
            this.sendScriptDataList();
            debug.log("注册程序动作脚本中用到的数据库变量 -> ok");
            //注册中间变量才
            this.registerMidVar();
            debug.log("注册中间变量才 -> ok");
            //程序脚本实例化
            this.executionScript(this.makeProjectFunc);
            debug.log("程序脚本实例化 -> ok");
            //按键动作实例化
            this.makeKeyFunc();
            debug.log("按键动作实例化 -> ok");
            //按键动作注册
            this.registerKeyFunc();
            debug.log("按键动作注册 -> ok");
            //注册自定义函数
            this.registerUserFunc();
            debug.log("注册自定义函数 -> ok");
            //条件动作实例化
            this.makeEventFunc();
            debug.log("条件动作实例化 -> ok");
            //应用程序动作
            this.executionScript(this.entranceFunc);
            debug.log("应用程序动作 -> ok");
            //数据改变动作
            this.varEventAction();
            debug.log("数据改变动作 -> ok");
            //渲染
            this._fcRequestAnimationFrame(this.onTimer.bind(this));
            debug.log("启动绘制 -> ok");
            this.dbCom.sendMessage({head:"getUser"},function(err,result){
                this.UserMessage = result;
            }.bind(this))
            //根据启动信息及url信息启动工程
            this.jsonSystemRoot();
        },

        initDataSource(){
            axios.all([
                axios.get(window.debugFWebView + this.projectName + "/dataSourceTags.json"),
                axios.get(window.debugFWebView + this.projectName + "/tagConfig.json")
            ]).then(axios.spread(function (dataSourceTags, tagConfig) {
                this.tagsTreeData[0] = dataSourceTags.data;
                this["tagConfig"] = tagConfig.data;
            }.bind(this))).catch((error) => {
                this.tagsTreeData[0] = {
                    title: '未找到数据库点文件',
                    expand: true,
                    children: []
                };
                this["tagConfig"] = {
                    DESC  : "Description",
                    INDEX : "TagId ",
                    NAME : "LongName",
                    PV : "value",
                    TIME : "time"
                }
            });
            
            
        },
        //初始化分辨率
        initScreenAdj(){

            this.scaleWidth = this.screenWidth;
            this.scaleHeight = this.screenHeight;
            
            var arrDPI = new Array;
            if (window.screen.deviceXDPI) {
                arrDPI = window.screen.deviceXDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI = parseInt(tmpNode.offsetWidth);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            this.arrDPI = arrDPI;
        },
        //中间变量注册
        registerMidVar(){
            this.midVar.forEach(function(curMidVar){
                // 数据改变动作的中间变量，无法再 数据改变函数中再次监听，故定义再这里
                for(var k in this.varChangeAction){
                    var name = this.varChangeAction[k].varName.substring(15,this.varChangeAction[k].varName.length-6);
                    if(curMidVar.name == name){
                        curMidVar.changeAction =  this.varChangeAction[k].changeAction;
                    }
                }
                if(curMidVar.type == "int"){
                    curMidVar.firstvalue = parseInt(curMidVar.firstvalue);
                }else if(curMidVar.type == "double"){
                    curMidVar.firstvalue = parseFloat(curMidVar.firstvalue);
                }
                var registerScript = {
                    "name" : curMidVar.name,
                    "type" : curMidVar.type,
                    "firstvalue" : curMidVar.firstvalue,
                    "save" : curMidVar.save,
                    "readOnly" : curMidVar.readOnly,
                    "isCreate" : true,
                    "changeAction" : [curMidVar.changeAction],
                }
                
                if(window.__systemMidVar){
                    window.__systemMidVar[curMidVar.name] = registerScript;
                }else{
                    window.__systemMidVar = {}
                    window.__systemMidVar[curMidVar.name] = registerScript;
                }
                registerScript.saveMidVar = this.saveMidVar.bind(this);
                // Object.defineProperty(window.__systemMidVar[curMidVar.name],"value",{
                //     set: function(value) {
                //         if(this.readOnly == false){
                //             if(this.type == "string"){
                //                 //如果是数字转换为字符串
                //                 this.firstvalue = typeof value != "string" ? value.toString() : value;
                //             }else if(this.type == "int"){
                //                 if(value === true){
                //                     value = 1;
                //                 }else if(value === false){
                //                     value = 0;
                //                 }
                //                 this.firstvalue = parseInt(value);
                //             }else{
                //                 if(value === true){
                //                     value = 1;
                //                 }else if(value === false){
                //                     value = 0;
                //                 }
                //                 this.firstvalue = parseFloat(value);
                //             }
                //             if(this.isCreate == false && this.save){
                //                 this.saveMidVar(this);
                //             }else{
                //                 this.isCreate = false;
                //             }
                //             for(var i = 0; i < this.changeAction.length;i++){
                //                  Vue.prototype.fvScript.executionScript(this.changeAction[i]) 
                //             }
                            
                //         }else if(this.isCreate){
                //             if(this.type == "string"){
                //                 this.firstvalue = typeof value != "string" ? value.toString() : value;
                //             }else if(this.type == "int"){
                //                 this.firstvalue = parseFloat(value);
                //             }else{
                //                 this.firstvalue = parseInt(value);
                //             }
                //             this.isCreate = false;
                //         }else{
                //             console.warn("不可以对只读的变量" + this.name + "赋值");
                //         }
                        
                //     },
                //     get : function(){
                //         return this.firstvalue;
                //     }  
                // });
                switch(curMidVar.type){
                    case "double":
                    window.__systemMidVar[curMidVar.name].minvalue = parseFloat(curMidVar.minvalue);
                    window.__systemMidVar[curMidVar.name].maxvalue = parseFloat(curMidVar.maxvalue);
                    window.__systemMidVar[curMidVar.name].value = parseFloat(curMidVar.firstvalue);
                    break;
                    case "string":
                    window.__systemMidVar[curMidVar.name].value = curMidVar.firstvalue;
                    break;
                    case "int":
                    window.__systemMidVar[curMidVar.name].minvalue = parseInt(curMidVar.minvalue);
                    window.__systemMidVar[curMidVar.name].maxvalue = parseInt(curMidVar.maxvalue);
                    window.__systemMidVar[curMidVar.name].value = parseInt(curMidVar.firstvalue);
                    break;
                }
            }.bind(this));
            this.setOnDvVar();
        },
        setOnDvVar(){
            this.midVar.forEach(function(curMidVar){
                Object.defineProperty(window.__systemMidVar[curMidVar.name],"value",{
                    set: function(value) {
                        if(this.readOnly == false){
                            if(this.type == "string"){
                                //如果是数字转换为字符串
                                this.firstvalue = typeof value != "string" ? value.toString() : value;
                            }else if(this.type == "int"){
                                if(value === true){
                                    value = 1;
                                }else if(value === false){
                                    value = 0;
                                }
                                this.firstvalue = parseInt(value);
                            }else{
                                if(value === true){
                                    value = 1;
                                }else if(value === false){
                                    value = 0;
                                }
                                this.firstvalue = parseFloat(value);
                            }
                            if(this.isCreate == false && this.save){
                                this.saveMidVar(this);
                            }else{
                                this.isCreate = false;
                            }
                            for(var i = 0; i < this.changeAction.length;i++){
                                 Vue.prototype.fvScript.executionScript(this.changeAction[i]) 
                            }
                            
                        }else if(this.isCreate){
                            if(this.type == "string"){
                                this.firstvalue = typeof value != "string" ? value.toString() : value;
                            }else if(this.type == "int"){
                                this.firstvalue = parseFloat(value);
                            }else{
                                this.firstvalue = parseInt(value);
                            }
                            this.isCreate = false;
                        }else{
                            console.warn("不可以对只读的变量" + this.name + "赋值");
                        }
                        
                    },
                    get : function(){
                        return this.firstvalue;
                    }  
                });
            }.bind(this));
        },
        //程序脚本实例化
        makeProjectFunc(){
            this.entranceFunc = this._fcFunction(this.projectAction.entrancescript);
            this.exitFunc = this._fcFunction(this.projectAction.exitscript);
            this.timerFunc = this._fcFunction(this.projectAction.timerscript);
            
        },
        //按键动作实例化
        makeKeyFunc(){
            this.keyAction.forEach((curAction)=>{
                curAction.downFlag = 0;
                curAction.keyDownFunc = this._fcFunction(curAction.keyDownScript);
                curAction.keyUpFunc = this._fcFunction(curAction.keyUpScript);
                curAction.keyDownOnTimerUnit = this._fcFunction(curAction.keyDownOnTimerScript);
                curAction.keyDownOnTimerFunc = function(){
                    if(curAction.downFlag == 0) return;
                    curAction.keyDownOnTimerUnit();
                    setTimeout(curAction.keyDownOnTimerFunc,curAction.keyDownOnTimer);
                }
            });
        },
        //条件动作实例化
        makeEventFunc(){
            //条件动作
            this.eventAction.forEach((curAction)=>{
                curAction.eventFunc = this._fcFunction("return " + curAction.eventScript);
                curAction.actionFunc = this._fcFunction( curAction.actionScript);
                curAction.timeStamp = 0;
                curAction.lastEventFlag = 0;
            });
        },
        //按键动作注册
        registerKeyFunc(){
            document.onkeydown = function(evt){
                this.keyAction.forEach((curAction)=>{
                    if(String.fromCharCode(evt.keyCode) == curAction.key){
                        if((curAction.ctrlState ^ evt.ctrlKey)==0 && (curAction.shiftState ^ evt.shiftKey)==0){
                            if(!evt.repeat){
                                this.executionScript(curAction.keyDownFunc);
                                curAction.downFlag = 1;
                                this.executionScript(curAction.keyDownOnTimerFunc);
                                
                            }
                        }
                    }
                });
            }.bind(this);
            document.onkeyup = function(evt){
                this.keyAction.forEach((curAction)=>{
                    if(String.fromCharCode(evt.keyCode) == curAction.key){
                        if(evt.type == "keyup") curAction.downFlag = 0;
                        if((curAction.ctrlState ^ evt.ctrlKey)==0 && (curAction.shiftState ^ evt.shiftKey)==0){
                            if(!evt.repeat){
                                curAction.downFlag = 0;
                                this.executionScript(curAction.keyUpFunc);
                                
                            }
                        }
                    }
                });
            }.bind(this);
        },
        //用户自定义函数注册
        registerUserFunc(){
            //注册自定义函数
            this.userFunction.forEach((curUserFunc)=>{
                if(curUserFunc.funcScript.indexOf("await") != -1){
                    var registerStr = 'return new AsyncFunction';
                }else{
                    var registerStr = 'return new Function';
                }
                registerStr += '(';
                if(curUserFunc.funcPar){
                    for(var i = 0;i<curUserFunc.funcPar.length; i++){
                        var curPar = "'" + curUserFunc.funcPar[i] + "'";
                        registerStr += curPar + ',';
                    }
                }
                registerStr += "\"try{" + curUserFunc.funcScript  +"}catch(e){console.log(e.stack);}\"";
                registerStr += ')';
                registerStr += ';';
                Vue.prototype.fvScript.addFvObjectEx(curUserFunc.funcName,Function(registerStr)());
            });
        },
        //执行程序周期脚本
        runProjectAction(){
            var tempTimerStamp = new Date().valueOf();
            if(tempTimerStamp - this.timeStamp >= this.projectAction.timer){
                this.timeStamp = tempTimerStamp;
                this.executionScript(this.timerFunc);
            }
        },
        //执行条件动作
        runEventAction(){
            this.eventAction.forEach(async (curAction) => {
                curAction.lastEventFlag = await this.executionScript(curAction.eventFunc);
                if(curAction.lastEventFlag){
                    var tempStamp = new Date().valueOf();
                    if(tempStamp - curAction.timeStamp >= curAction.eventTimer){
                        this.executionScript(curAction.actionFunc);
                        curAction.timeStamp = new Date().valueOf();
                    }
                }
            });
        },
        //数据改变动作
        varEventAction(){
            if(this.isInitComplateTwo == false){
                if(this.varChangeAction != undefined){
                    this.varChangeAction.forEach(async (curAction)=>{
                        var varName = curAction.varName;
                        if(curAction.isDbVar){
                            var varParStr = varName.replace(/^(.*)\.([^\.]+)/g,"$1");
                            var varLastStr = varName.replace(/^(.*)\.([^\.]+)/g,"$2");
                            //注册点
                            this.$store.state.system.$.dbCom.declareTags([{firstValue:0,name:varName.substring(9,varName.length-3)}]);
                            this.$store.state.system.$.dbCom.sendMessage({
                                head : "registryTag",
                                dbVar : [varName.substring(9,varName.length-3)]
                            },(result)=>{});

                            var obj = await Vue.prototype.fvScript.executionScript("return " + varParStr);
                            if(obj){
                                obj.varChangeAction = AsyncFunction(curAction.changeAction);
                                Object.defineProperty(obj, "__old_" + varLastStr, {
                                    set : function(value){
                                        if(this[varLastStr] !== value){
                                            Vue.prototype.fvScript.executionScript(this.varChangeAction);
                                        }
                                    }
                                });
                            }else{
                                console.log("未找到数据改变动作的指定的数据：" + varParStr);
                            }
                            
                        }else{
                            var obj = await Vue.prototype.fvScript.executionScript("return " + varName);
                            if(obj && obj.changeAction){
                                obj.changeAction.push(AsyncFunction(curAction.changeAction));
                            }else{
                                //判断是否是系统函数毫秒  目前使用，弊端太多后续修改
                                if(varName.indexOf("$Second")!=-1){//秒
                                    setInterval(()=>{
                                    Vue.prototype.fvScript.executionScript(curAction.changeAction);
                                    },3000);
                                }else if(varName.indexOf("$Minute")!=-1){//分
                                    setInterval(()=>{
                                    Vue.prototype.fvScript.executionScript(curAction.changeAction);
                                    },63000);
                                }
                            }
                        }
                    });
                }
            }
            
        },
        getConnectStr(name){
            if(this.jsonSysRootConfig.connectStrs)
                return this.jsonSysRootConfig.connectStrs[name];
            else
                return null;
        },
        startBackstage(backstages,excelServer){
            for(var i = 0; i < backstages.length;i++){
                var oneBackstage = backstages[i];
                //会有为null的请况 跳出本次循环
                if(oneBackstage.config == null){
                    continue;
                }
                this.dbCom.sendMessage({
                    head : "backstage",
                    message : {
                        head : oneBackstage.config.fctype,
                        type : "start",
                        message : oneBackstage
                    }
                },(err,result)=>{
                    if(err){
                        console.warn(err);
                    }else{
                        var backstageObj = new backstageClass[result.config.fctype](this,result)
                        Vue.prototype.fvScript.addFvObjectEx(result.name,backstageObj);
                    }
                })
            }
            //excelServer后台组件启动
            this.dbCom.sendMessage({
                head : "backstage",
                message : {
                    head : "fvExcelServer",
                    type : "start",
                    message : excelServer
                }
                
            },(err,result)=>{
                if(err){
                    console.warn(err);
                }else{
                    console.log("excel模板服务器启动");
                }
            });
            
        },
        //获取Sysroot配置信息，并打开初始启动窗口
        jsonSystemRoot(){
            this.updataProgress(60,this.languageName == "ch"? "读取系统参数" :"Read system parameters");
            debug.log("开始 -> 读取系统初始启动相关参数");
            //系统初始启动相关参数读取
            var projectName = this.projectName;
            
            axios.get(window.debugFWebView + this.projectName+"/SysRoot.json").then(function(result){
                var jsonRoot = result.data;
                this.viewList = result.data.initView;
                this.shortcutMenu = result.data.shortcutMenu;
                this.__callViewFunction("showMenu",[jsonRoot.isShowMenu]);
                
                this.updataProgress(80,this.languageName == "ch"? "启动窗口" :"Launch window");
                FColorToRGB.setCustomColor(jsonRoot.customColor);
                debug.log("读取系统初始启动相关参数 -> ok");
                this.jsonSysRootConfig = jsonRoot;
                this.disableZoom = jsonRoot.disableZoom;
                this.labelSys = {
                    "labelName": jsonRoot.labelName,
                    "labelNumber": jsonRoot.labelNumber
                };
                this.startBackstage(this.jsonSysRootConfig.backstage,this.jsonSysRootConfig.connectStrs);
                debug.log("后台组件启动消息已发送 -> ok");
                this.textInvalid = jsonRoot.textInvalid ? jsonRoot.textInvalid : "?";
                window.textInvalid = jsonRoot.textInvalid ? jsonRoot.textInvalid : "?";
                var allWinxowsOpen = new Array()
                if(this.isUrlWindow){
                    //从url中获取到了启动信息,忽略初始启动窗口配置,根据url启动
                    //初始化url中设置的中间变量
                    for(var p in this.initMiddleVar){
                        if(window.__systemMidVar[p]){
                            if(window.__systemMidVar[p].readOnly || window.__systemMidVar[p].save){
                                alert("不能在url改变一个只读的或者可同步的中间变量,此次赋值无效")
                            }else{
                                window.__systemMidVar[p].value = this.initMiddleVar[p];
                            }
                        }
                    }
                    //遍历启动窗口
                    for(var p in this.startWindows){
                        if(this.isCorrectFormat(p)){
                            console.warn("错误的窗口名称：" + p);
                            continue;
                        }
                        debug.log("需要打开窗口 ： " + p);
                        allWinxowsOpen.push(this.$store.state.system.manager.$.openView(p,this.startWindows[p]));
                    }
                }else{
                    //从配置中启动窗口
                    if(window.isApp()){
                        //判断是否是手机端
                        var initView = jsonRoot.initAppView
                    }else{
                        var initView = jsonRoot.initView;
                    }
                    //遍历启动窗口
                    if(initView && initView.length > 0){
                        this.startWindows = {};
                        for(var i = 0; i < initView.length;i++){
                            if(this.isCorrectFormat(initView[i])){
                                console.warn("错误的窗口名称：" + initView[i]);
                                continue;
                            }else{
                                allWinxowsOpen.push(this.$store.state.system.manager.$.openView(initView[i],undefined,undefined,"win"));
                            }
                        }
                    }else{
                         this.$store.state.system.noWindow.$.show(1);
                    }
                }
                
                Promise.all(allWinxowsOpen).then(()=>{
                    this.isInitComplate = true;
                    this.isInitComplateTwo = false;
                    this.$store.state.system.$.updataProgress(100,this.languageName == "ch"? "准备完成" :"Ready to finish");
                    //这是标签名称
                    if(this.labelSys.labelNumber == 2){
                        document.title = this.labelSys.labelName;//自定义
                    }else if(this.labelSys.labelNumber == 0){
                        document.title = this.projectName;//工程名称
                    }
                }).catch((error)=>{
                    this.isShowProgress = false;
                });
                //获取全局右键脚本
                if(jsonRoot.contextMenu){
                    this.ct = jsonRoot.contextMenu;
                }
            }.bind(this)).catch(function(error){
                console.log(error)
            });
        },
        //解析URL 获取初始窗口信息
        getUrlParam(){
            
            if(location.search == ""){
                return false;
            }
            var url = location.search.substring(1);
            var param = url.split("&");
            var ssoLogin = {};
            var toUrlLogIn = false;
            for(var i = 0; i < param.length;i++){
                var obj = decodeURIComponent(param[i]).split("=");
                if(obj[0] == "ssoLogin"){
                    ssoLogin = this.analyticParam(obj[1]);
                    toUrlLogIn = true;
                }else if(obj[0] == "middle"){
                    this.initMiddleVar = this.analyticParam(obj[1]);
                }else if(obj[0] == "language"){
                    this.ishasLanguage = true;
                    this.languageName = obj[1];
                }else if(obj[0] == "disableZoom"){//是否启用缩放
                    this.isUrlWindow = true;
                    this.disableZoom = obj[1];
                }else if(obj[0] == "embedView"){//是否是嵌入视图
                    this.isUrlWindow = true;
                    this.embedView = obj[1];
                }else if(obj[0] == "delIndexDB"){//清除indexDB缓存
                    if(obj[1] == "[]"){
                        window.getIndexDB(this.projectName);
                    }else{
                        var str = obj[1].substring(1,obj[1].length-1);
                        var arr = str.split(",");
                        for(var i=0; i<arr.length; i++){
                            window.getIndexDB(this.projectName,arr[i])
                        }
                    }
                }else if(obj[0] == "tokey"){//清除indexDB缓存
                    this.ttokey = obj[1];
                }else{
                    this.isUrlWindow = true;
                    this.startWindows[obj[0]] = this.analyticParam(obj[1]);
                }
            }
            if(toUrlLogIn){
                return ssoLogin;
            }
        },
        analyticParam (paramStr){
            if(paramStr == "{}" || paramStr == null || paramStr == undefined){
                return {};
            }
            paramStr = paramStr.substring(1,paramStr.length - 1); 
            var params = paramStr.split(",");
            var data = {};
            for(var i = 0; i < params.length;i++){
                var obj = params[i].split(":");
                var key = obj[0];
                var value = obj[1].toString();
                data[key] = value;
            }
            return data;
        },
        async getData(){
            await new Promise((resolve,reject)=>{
                this.dbCom.sendMessage({
                    "head": "dataLayer",
                    "message" : {
                        "head": "getData",
                        "dbVarNameList":[]
                    }
                },(error,realData)=>{
                    this.dbCom.realBack(error,realData);
                    resolve();
                });
            })
            
        },
        
        //全局动画入口
        onTimer(time){
            try{
                //数据刷新周期
                if(time - this.lastRealValueTime >= this.jsonSysRootConfig.dataChangeCycl){
                    this.lastRealValueTime = time;
                    this.dbCom.sendMessage({
                        "head": "dataLayer",
                        "message" : {
                            "head": "getData",
                            "dbVarNameList":[]
                        }
                    },(error,realData)=>{
                        //启用回放不再调用实时点
                        if(!this.$store.state.system.historyPlaybackControl.$.openPlayback){
                            this.dbCom.realBack(error,realData);
                        }
                        if(this.isInitComplate){
                            for(var p in this.$store.state.system.manager){
                                if(p == "$") continue;
                                this.$store.state.system.manager[p].$.onUpdata();
                            }
                        }
                    });
                }
                //ui刷新周期
                if(this.isInitComplate && time - this.lastUiRefreshTime >= this.jsonSysRootConfig.uiRefreshCycl){
                    this.lastUiRefreshTime = time;
                    //程序脚本周期执行
                    this.runProjectAction();
                    //条件动作执行
                    this.runEventAction();
                    for(var p in this.$store.state.system.manager){
                        if(p == "$") continue;
                        if(this.$store.state.system.manager[p].$.onTimer){
                            this.$store.state.system.manager[p].$.onTimer(time);
                        }
                    }
                }
                this._fcRequestAnimationFrame(this.onTimer.bind(this));
            }catch(e){
                console.log("catch error: " + e.stack);
            }
        },
        //获取全局右键动画
        contextMenu(key){
            for(var i = 0 ;i < this.ct.length; i++) {
                if(this.ct[i].title == key){
                    return this.ct[i].item;
                }
            }
        },
        //是否为正确的窗口名称
        isCorrectFormat(winName){
            var re = /^[0-9]/;  //判断是否为正确的点名格式，只包含数字、字母、_并以字母开头   
            if(re.test(winName)) 
                return false;
            var re = /-|~|!|@|#|\$|%|\^|\&|\*|\(|\)|\{|\}|\[|\]/;
            if(re.test(winName)) 
                return false; 
        },

        saveMidVar(midVar){
            var data ={
                "head" : "ModifyMidVar",
                "message" : {
                    "project" : this.projectName,
                    "name" : midVar.name,
                    "value" : midVar.value
                }
            }
            this.dbCom.sendMessage(data,function(err,result){});
        },

        _regTempAlarmObj(temp,property){
            if(window.alarmContent){
                if(window.alarmContent[temp[0]]){
                    if(window.alarmContent[temp[0]][temp[1]] === undefined){
                        window.alarmContent[temp[0]][temp[1]] = false
                    }
                }else{
                    window.alarmContent[temp[0]] = {};
                    window.alarmContent[temp[0]][temp[1]] = false;
                    this.alarmTagList.push({
                        "modelRule" : temp,
                        "property" : property
                    });
                    this.dbCom.sendMessage({
                        "head" : "regAlarm",
                        "message" : temp[0] + "." + temp[1]
                    },function(err,resule){
                    });
                }
            }else{
                window.alarmContent = {}
                window.alarmContent[temp[0]] = {};
                window.alarmContent[temp[0]][temp[1]] = false;
                this.alarmTagList.push({
                    "modelRule" : temp,
                    "property" : property
                });
                this.dbCom.sendMessage({
                    "head" : "regAlarm",
                    "message" : temp[0] + "." + temp[1]
                },function(err,resule){});
            }
        },

        _fcFunction() {
            try{
                return new AsyncFunction (arguments[0]);
            }
            catch (err){
                console.log("脚本初始化失败");
                return function () {
                    console.log("初始化失败的脚本")
                }
            }
        },

        sendScriptDataList(view){
            var dbVarList=[];
            for(var i = 0; i < this.dbVar.length; i++){
                //拼接窗口数据库变量表单
                dbVarList.push(this.dbVar[i].name);
            }
            this.dbCom.sendMessage({
                "head": "openView",
                "dbVar": dbVarList
            });

            // this.varChangeAction.forEach(function(curAction){
            //     var varName = curAction.varName;
            //     var varParStr = varName.replace(/^(.*)\.([^\.]+)/g,"$1");
            //     this.dbVar.push({
            //         "name" : varParStr,
            //         "firstValue" : 0
            //     });
            // }.bind(this));
            this.dbCom.declareTags(this.dbVar);
        },

        _fcRequestAnimationFrame(callbackFunc){
            requestAnimationFrame(callbackFunc);
        },

        getImgCache(src){
            return new Promise((resolve,reject)=>{
                if(this.imgs[src] == undefined){
                    var img = new Image();
                    img.src = src;
                    img.onload = () => {  
                        this.imgs[src] = img;
                        resolve(this.imgs[src])
                    }
                    img.onerror = () =>{
                        img.src = require('./assets/errPic.jpg');
                        this.imgs[src] = img;
                        reject(this.imgs[src])
                    }
                }else{
                    resolve(this.imgs[src])
                }
            })
        },
        
        //解决app底部菜单点击过快导致页面加载错位
        async executionScript(script,param){
            return await Vue.prototype.fvScript.executionScript(script,param);
        },
        //退出登录/退出程序执行
        async LogOut(){
            var db = await this.setDB();
            //退出程序
            if(db){//取db---
                var tokey =  db;//this.getCookie("name");//取db---
            }else{
                var tokey = undefined;
            }
            this.executionScript(this.exitFunc);
            axios.post(window.debugFWebView + "/logout",{},{
                headers: {'X-Requested-With': 'XMLHttpRequest',tokey:tokey},
            }).then(function(result){
                this.isInitComplate = false;
                this.isInitComplateTwo = true;//退出窗口再次登录，需要
                this.toLogin(this.projectConf);
            }.bind(this)).catch(function (error) {
                this.$Message.error(error);
            }.bind(this));
        },
        async isAlarmCenter(){
            return new Promise((resolve)=>{
                axios.get(window.debugFWebView + "/isAlarmCenterStart").then(function(result){
                    resolve(result.data);
                }.bind(this)).catch(function (error) {
                    resolve(false);
                }.bind(this));
            })
        },
        async toLogin(){
            this.$store.state.system.dragResize.$.isdisplay = 0;
            this.projectConf.showAlarm = await this.isAlarmCenter();
            var data = this.projectConf;
            //未登录，跳转登录页面
            if(isApp()){
                var html = this.$store.state.system.loginApp;
            }else{
                this.__callViewFunction("showMenu",[true]);
                //配置文件配置定制的登录页名称
                if(data.logoName){
                    var html = this.$store.state.system[data.logoName];
                    if( html== undefined){
                        this.$Message.error("登录页不正确请确认是否是："+data.logoName);
                        var html = this.$store.state.system.login;
                    }
                }else{
                    var html = this.$store.state.system.login;
                }
            }
            html.$.show(true,this.dbCom.getLinkId(),data);
            html.$.waiting().then(async(result)=>{
                html.$.show(false,this.dbCom.getLinkId(),data);
                // document.cookie = "name="+result.data.tokey;//存db---
                await this.setDB(result.data.tokey)
                this.cookieTokey = result.data.tokey;
                this.resultData = result.data;
                this.userName = result.userName;
                this.userLevel = result.userLevel;
                this.$store.state.system.$.dbCom.sendMessage({"head" : "getProperty"},function(err,message){
                    window["tagProprety"] = message;
                    this.routes(result);
                }.bind(this))
            }).catch(function (error) {
                this.$Message.error(error);
            }.bind(this));

        },
        /**
         * 打印当前页
         */
        toPrintView(){
            window.print();
        },
        /**
         * 打印制定窗口
         */
        Print(winName){
            var newWindow=window.open("?"+winName,"_blank");
            //目前使用 window.open 的回调， 判断在148 行； 

            //延迟打印页面， 否则页面还没有绘制完成开始打印
            // setTimeout(function(){//避开异步问题
            //     newWindow.print();
            // }.bind(this),5000);
        },

        routes(data){
            this.$store.state.system.webmaster.$.show(false);
            this.$store.state.system.alarmCenter.$.show(false);
            switch(data.type){
                case "SmartWorx":
                    //登陆后设置显隐
                    axios.get(window.debugFWebView + this.projectName+"/SysRoot.json").then(function(result){
                        this.disableZoom = result.disableZoom;
                        this.labelSys = {
                            "labelName": result.labelName,
                            "labelNumber": result.labelNumber
                        };
                        /**如果是app禁用该组件*/
                        if(!isApp()){
                            /**参数：缩放配置* 作用：全局缩放组件显隐*/
                            this.shortcutMenu = result.data.shortcutMenu;
                            this.$store.state.system.dragResize.$.openShow(result.data.shortcutMenu);
                        }
                    }.bind(this)).catch(function(error){
                        console.log(error)
                    });
                    if(this.isJsonNull){
                        this.resource = {};
                        this.initProject();
                    }else{
                        axios.get(window.debugFWebView + this.projectName + "/Resources.json").then((configure)=>{
                            this.resource = configure.data;
                            if(this.ishasLanguage == false){
                                this.languageName = configure.data.default;
                            }else if(this.resource[this.languageName] == undefined){
                                this.languageName = configure.data.default;
                            }
                            this.__callViewFunction("setLanguage",[this.languageName]);
                            this.initProject();
                        }).catch((errorResult)=>{
                            console.warn("未加载到语言资源文件");
                        });
                    }
                    
                break;
                case "webmaster":
                    //在此跳转到后台管理
                    this.$store.state.system.webmaster.$.show(true);
                break;
                case "alarm":
                    this.isShowProgress =  false;
                    this.$store.state.system.alarmCenter.$.show(true,data.key,this.userName);
                break;
                default:
                    if(this.isJsonNull){
                        this.resource = {};
                        this.initProject();
                    }else{
                        axios.get(window.debugFWebView + this.projectName + "/Resources.json").then((configure)=>{
                            this.resource = configure.data;
                            if(this.ishasLanguage == false){
                                this.languageName = configure.data.default;
                            }else if(this.resource[this.ishasLanguage] == undefined){
                                this.languageName = configure.data.default;
                            }
                            this.__callViewFunction("setLanguage",[this.languageName]);
                            this.initProject();
                        }).catch((errorResult)=>{
                            console.warn("未加载到语言资源文件");
                        });
                    }
                break;
            }
        },

        upData(){
            //window.reload()
        },

        isMidVar(){

        },

        getResource(id){
            if(this.resource[this.languageName]){
                if(this.resource[this.languageName][id] != ""){
                    if(this.resource[this.languageName][id] ==  undefined){
                        return id;
                    }
                    return this.resource[this.languageName][id];
                }else if(this.resource[this.languageName][id] === ""){
                    return id;
                    
                }
            }
        },
        //返回主页
        Homepage(){
            this.$store.state.system.manager.$.closeAllView();
            for(let p in this.viewList){
                this.$store.state.system.manager.$.openView(this.viewList[p]) 
            }
        },
        //倍数为2
        zoomMultiple(step){
            //计算放大缩小倍数，防止过大或过小导致闪屏
            //32767 非ie浏览器内核支持的canvas的最大宽度和高度
            //alert(this.screenWidth + step);
            if(this.screenWidth >= 32767 ) {
                if(step > 0){
                    this.screenWidth = 32767;
                    return true;
                }
            }
            if(this.screenWidth <= 330){
                if(step < 0){
                    this.screenWidth = 330;
                    return true;
                }
            }
            if(this.screenHeight >= 32767){
                if(step > 0){
                    this.screenHeight = 32767;
                    return true;
                }
            }
            if(this.screenHeight <= 230){
                if(step < 0){
                    this.screenHeight = 230;
                    return true;
                }
            }
            return false;
        },
        //倍数为0.5
        zoomMultiple1(step){
            //计算放大缩小倍数，防止过大或过小导致闪屏
            //32767 非ie浏览器内核支持的canvas的最大宽度和高度
            
            
            if(this.screenWidth >= 32767 ) {
                if(step > 0){
                    this.screenWidth = 32767;
                    return true;
                }
            }
            if(this.screenWidth <= 200){
                if(step < 0){
                    this.screenWidth = 200;
                    return true;
                }
            }
            if(this.screenHeight >= 32767){
                if(step > 0){
                    this.screenHeight = 32767;
                    return true;
                }
            }
            if(this.screenHeight <= 100){
                if(step < 0){
                    this.screenHeight = 100;
                    return true;
                }
            }
            if(step > 0){
                //缩放回来需要把 缩放比例设置回来
                if(this.screenWidth>390 && this.screenWidth<420 ){
                    window.devicePixelRatio = 2;
                }
            }
            return false;
        },
        touchmoveOther(e){
            //如果是禁用缩放
            if(this.disableZoom == 1 && Math.abs(window.orientation) === 0){
                if(this.touchLength <= 1){
                    //单指拖动
                    //计算手指移动距离和实际窗口需要移动距离计算
                    if(this.touchLeftX == 0 || this.touchLeftY == 0){
                        this.touchLeftX = e.touches[0].pageX;
                        this.touchLeftY = e.touches[0].pageY;
                    }
                    var x = (e.touches[0].pageX - this.touchLeftX) * (this.screenWidth / innerWidth);
                    var y = (e.touches[0].pageY - this.touchLeftY) * (this.screenHeight / innerHeight);
                    //alert(e.touches[1].pageX);
                    //alert(this.touchLeftX);
                    this.touchLeftX = e.touches[0].pageX;
                    this.touchLeftY = e.touches[0].pageY;
                    //用于缩放后 后在次打开新窗口
                    this.zoomList.x +=y;
                    this.zoomList.y +=x;
                    if (Math.abs(window.orientation) === 90){
                        for(let p in this.$store.state.system.manager){
                            if(p != "$"){
                                this.$store.state.system.manager[p].$.setPosition(x,y);
                                this.$store.state.system.manager[p].$.onDraw();
                            }
                        }
                    }else{
                        for(let p in this.$store.state.system.manager){
                            if(p != "$"){
                                this.$store.state.system.manager[p].$.setPosition(x,0);
                                this.$store.state.system.manager[p].$.onDraw();
                            }
                        }
                    }
                }
                return;
            }

            if(this.touchLength > 1){
                //双指放大
                var moveLength = this.getDistance(e.touches[0],e.touches[1]); //得到缩放比例，getDistance是勾股定理的一个方法
                var step = (this.lastMoveLength - moveLength) * window.devicePixelRatio;
                if(this.lastMoveLength == 0){
                    this.lastMoveLength = moveLength;
                    return;
                }
                
                this.lastMoveLength = moveLength;
                //计算双指之间矩形中心坐标
                var center = this.getCenterPos(e.touches[0],e.touches[1]);
                //计算放大缩小倍数，防止过大或过小导致闪屏
                if(window.devicePixelRatio == 2){
                    if(this.zoomMultiple(step)) {
                        window.devicePixelRatio = 1;
                    }
                }
                if(window.devicePixelRatio == 1){
                    if(this.zoomMultiple1(step)) return;
                }
                this.$store.state.system.$.isZoom = true;
                //放大或者缩小
                //缩放步长需要计算高分屏。移动时不需要计算。实测此结果。原因未知。
                var zy = this.screenHeight / this.screenWidth;
                this.screenWidth += step;
                this.screenHeight += step * zy;
                //0.15如何来。没有理论依据。暂时代码需要查找原因
                var x = step * ((center.x / innerWidth));
                var y = step * zy * ((center.y / innerHeight));
                this.zoomList.x += x;
                this.zoomList.y += y;
                if(this.animationType){
                    this.animationType = false;
                }
                for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        this.$store.state.system.manager[p].$.repaint({
                            x : x,
                            y : y
                        });
                        this.$store.state.system.manager[p].$.onDraw();
                    }
                }
              
            }else if(this.touchLength <= 1){
                //单指拖动
                //计算手指移动距离和实际窗口需要移动距离计算
                if(this.touchLeftX == 0 || this.touchLeftY == 0){
                    this.touchLeftX = e.touches[0].pageX;
                    this.touchLeftY = e.touches[0].pageY;
                }
                var x = (e.touches[0].pageX - this.touchLeftX) * (this.screenWidth / innerWidth);
                var y = (e.touches[0].pageY - this.touchLeftY) * (this.screenHeight / innerHeight);
                //alert(e.touches[1].pageX);
                //alert(this.touchLeftX);
                this.touchLeftX = e.touches[0].pageX;
                this.touchLeftY = e.touches[0].pageY;
                //用于缩放后 后在次打开新窗口
                this.zoomList.x +=y;
                this.zoomList.y +=x;
                if (Math.abs(window.orientation) === 90){
                    for(let p in this.$store.state.system.manager){
                        if(p != "$"){
                            this.$store.state.system.manager[p].$.setPosition(x,y);
                            this.$store.state.system.manager[p].$.onDraw();
                        }
                    }
                }else{
                    for(let p in this.$store.state.system.manager){
                        if(p != "$"){
                            this.$store.state.system.manager[p].$.setPosition(x,0);
                            this.$store.state.system.manager[p].$.onDraw();
                        }
                    }
                }
            }
        },
        touchmovePrivateApp(e){
            //如果是禁用缩放
            // if(this.disableZoom == 1){
            //     return;
            // }
            
            if(this.touchLength > 1){
                //用于判断窗口是否是 横向打开
                 for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        if( this.$store.state.system.manager[p].$.turn=="portrait"){
                            return;
                        }else if(this.$store.state.system.manager[p].$.turn=="portraits"){
                            return;
                        }
                    }
                }
                //双指放大
                var moveLength = this.getDistance(e.touches[0],e.touches[1]); //得到缩放比例，getDistance是勾股定理的一个方法
                var step = (this.lastMoveLength - moveLength) * devicePixelRatio;
                if(this.lastMoveLength == 0){
                    this.lastMoveLength = moveLength;
                    return;
                }
                this.lastMoveLength = moveLength;
                //计算双指之间矩形中心坐标
                var center = this.getCenterPos(e.touches[0],e.touches[1]);
                //计算放大缩小倍数，防止过大或过小导致闪屏
                 if(window.devicePixelRatio == 2){
                    if(this.zoomMultiple(step)) {
                        window.devicePixelRatio = 0.5;
                    }
                }
                if(window.devicePixelRatio == 0.5){
                    
                    if(this.zoomMultiple1(step)) return;
                }


                
                this.$store.state.system.$.isZoom = true;
                //放大或者缩小
                //缩放步长需要计算高分屏。移动时不需要计算。实测此结果。原因未知。
                var zy = this.screenWidth / this.screenHeight;

                this.screenHeight += step;
                this.screenWidth += step * zy;
                //0.15如何来。没有理论依据。暂时代码需要查找原因
                var y = step * ((center.x / innerWidth));
                var x = step * zy * ((center.y / innerHeight));
                this.zoomList.x += x;
                this.zoomList.y += y;
                if(this.animationType){
                    this.animationType = false;
                }
                for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        this.$store.state.system.manager[p].$.repaint({
                            x : x,
                            y : y
                        });
                        this.$store.state.system.manager[p].$.onDraw();
                    }
                }
              
            }else if(this.touchLength <= 1){
                
                //单指拖动
                //计算手指移动距离和实际窗口需要移动距离计算
                if(this.touchLeftX == 0 || this.touchLeftY == 0){
                    this.touchLeftX = e.touches[0].pageX;
                    this.touchLeftY = e.touches[0].pageY;
                }
                
                var x = (e.touches[0].pageX - this.touchLeftX) * (this.screenWidth / innerWidth);
                var y = (e.touches[0].pageY - this.touchLeftY) * (this.screenHeight / innerHeight);
                //alert(e.touches[1].pageX);
                //alert(this.touchLeftX);
                // console.log(e.touches[0].pageX +","+ this.touchLeftX)
                this.touchLeftX = e.touches[0].pageX;
                this.touchLeftY = e.touches[0].pageY;
                
                //用于缩放后 后在次打开新窗口
                this.zoomList.x +=y;
                this.zoomList.y +=x;
                
                for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        //DisplayCom 添加判断如果app打开标记带有横向的，设置判断上下不能拖动
                        if( this.$store.state.system.manager[p].$.turn=="portrait"){
                            this.$store.state.system.manager[p].$.setPosition(0,-x);
                        }else if(this.$store.state.system.manager[p].$.turn=="portraits"){
                            this.$store.state.system.manager[p].$.setPosition(0,-x);
                        }else{
                            this.$store.state.system.manager[p].$.setPosition(y,-x);
                        }
                        
                        this.$store.state.system.manager[p].$.onDraw();
                    }
                }
            }
        },
        //手指拖动事件
        touchmove(e){
            var isApp = false;
            var isView = false;
            for(let p in this.$store.state.system.manager){
                if(p != "$"){
                    if(this.$store.state.system.manager[p].$.fctype== "appView"){
                        // var isApp = true;
                    }else if(this.$store.state.system.manager[p].$.fctype== "view"){
                        var isView = true;
                    }
                }
            }
            if(isView==false) return;
            e.preventDefault();
            e.stopPropagation();
            if(this.embedView){
                this.touchmoveOther(e);
            }else{
                this.touchmovePrivateApp(e)
            }
        },

        getCenterPos(p1,p2){
            var x = p2.pageX - p1.pageX,
            y = p2.pageY - p1.pageY;
            return {
                x : p1.pageX + (x/2),
                y : p1.pageY + (y/2)
            }
        },

        getDistance(p1, p2) {
            var x = p2.pageX - p1.pageX,
            y = p2.pageY - p1.pageY;
            return Math.sqrt((x * x) + (y * y));
        },
        touchstart(e){
            this.animationType = true;
            if(this.touchLength <= 2){
                this.touchLength++;
                if(this.touchLength>2){
                    this.touchLength = 2;
                }
            }
            
        },
        /**
         * 手指抬起
         */
        touchend(e){
            //e.preventDefault();
            //e.stopPropagation();
            //有手指离开。不论时双指离开，还是单指离开。都清楚记录，设置动画绘制方式。并调用一次绘制
            // if(this.touchLength <= 0 ){
                
            // }
            
            this.touchLength--;
            if(this.touchLength<0){
                this.touchLength = 1;
            }
            this.animationType = false;
            this.lastMoveLength = 0;
            this.touchLeftX = 0;
            this.touchLeftY = 0;
        },

        onmouseup(e){
            //e.preventDefault();
            //e.stopPropagation();
            this.mouseDown = false;
            for(let p in this.$store.state.system.manager){
                if(p != "$"){
                     if(!this.$store.state.system.$.indexDB[0].isSvg){
                            if(this.mouseDown){
                                this.$store.state.system.manager[p].$.$refs.canvasNode.classList.add("supportStyle");
                            }else{
                                //清空所有窗口后会出现bug，所以要判断是否有
                                if(this.$store.state.system.manager[p].$.$refs.canvasNode){
                                    this.$store.state.system.manager[p].$.$refs.canvasNode.classList.remove("supportStyle");
                                }
                            }
                       
                        }else{
                             if(this.mouseDown){
                                this.$store.state.system.manager[p].$.$refs.svgNode.classList.add("supportStyle");
                            }else{
                                //清空所有窗口后会出现bug，所以要判断是否有
                                if(this.$store.state.system.manager[p].$.$refs.svgNode){
                                    this.$store.state.system.manager[p].$.$refs.svgNode.classList.remove("supportStyle");
                                }
                            }
                        }
                        
                   
                }
            }
            this.animationType = true;
        },
        //pc事件，用于缩放后拖动
        onmousedown(e){
            this.mouseDown = true;
            this.mouseDownPos = {
                x : e.clientX,
                y : e.clientY
            }
        },
        //在打开窗口获取鼠标位置 用于中心与鼠标位置对其
        onmousemoves(e){
            window.onmousemoveX = e.pageX;
            window.onmousemoveY = e.pageY;
            if(this.$store.state.system.$.isZoom == true && this.mouseDown){
                const ls = e.clientX - this.mouseDownPos.x;
                const lt = e.clientY - this.mouseDownPos.y;
                //用于缩放后拖拽  后在次打开新窗口
                this.zoomList.x +=ls ;
                this.zoomList.y +=lt ;
                this.mouseDownPos = {
                    x : e.clientX,
                    y : e.clientY
                }
                if(this.animationType){
                    this.animationType = false; 
                }
                for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        if(!this.$store.state.system.$.indexDB[0].isSvg){
                            this.$store.state.system.manager[p].$.$refs.canvasNode.classList.add("supportStyle");
                        }else{
                            this.$store.state.system.manager[p].$.$refs.svgNode.classList.add("supportStyle");
                        }
                        this.$store.state.system.manager[p].$.setPosition(ls,lt);
                        this.$store.state.system.manager[p].$.onDraw();
                    }
                }
            }
        },
        /*  
            参数：e 鼠标信息
            作用：鼠标中键操作时(滚轮缩放)被调用
        */
        onMouseScroll(e){
            e.stopPropagation();
            if(e.shiftKey){
                e=e || window.event;
                var step;
                if(e.wheelDelta){            //判断浏览器IE，谷歌滑轮事件
                    if(e.wheelDelta>0){  //当滑轮向上滚动时
                        step = -10;
                    }
                    if(e.wheelDelta<0){          //当滑轮向下滚动时
                        step = 10;
                    }
                }else if(e.detail){             //Firefox滑轮事件
                    if(e.detail>0){         //当滑轮向下滚动时
                        step = 10;
                    }
                    if(e.detail<0){            //当滑轮向上滚动时
                        step = -10;
                    }
                }
                this.$store.state.system.$.isZoom = true;
                
                //放大缩小最多5倍
                if(this.screenWidth > innerWidth * 5 ) {
                    if(step > 0){
                        return;
                    }
                }
                if(this.screenWidth < innerWidth / 5){
                    if(step < 0){
                        return;
                    }
                }
                if(this.screenHeight > innerHeight * 5){
                    if(step > 0){
                        return;
                    }
                }
                if(this.screenHeight < innerHeight / 5){
                    if(step < 0){
                        return;
                    }
                }
                var sy = innerWidth / innerHeight;
                this.screenWidth += step * sy;
                this.screenHeight += step ;
                var x = step * (e.pageX / innerWidth) * sy;
                var y = step * (e.pageY / innerHeight);
                //用于缩放后拖拽  后在次打开新窗口
                this.zoomList.x +=x ;
                this.zoomList.y +=y ;
                if(this.animationType){
                    this.animationType = false;
                }
                for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        if(!this.$store.state.system.$.indexDB[0].isSvg){
                            this.$store.state.system.manager[p].$.$refs.canvasNode.classList.add("my_close");
                        }else{
                            this.$store.state.system.manager[p].$.$refs.svgNode.classList.add("my_close");
                        }
                        this.$store.state.system.manager[p].$.zoomMagnification();
                        this.$store.state.system.manager[p].$.repaint({
                            x : x,
                            y : y
                        });
                        this.$store.state.system.manager[p].$.onDraw();
                    }
                }
            }
        },
        /*  
            参数：无
            作用：浏览器大小改变
        */
        onResize(){
            if (Math.abs(window.orientation) === 90) {
                var direction = "transverse";
            } else {
                var direction = "vertical";
            }
            setTimeout( ()=> { 
                for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        this.$store.state.system.manager[p].$.repaint(direction);
                        if(!this.$store.state.system.$.indexDB[0].isSvg){
                            this.$store.state.system.manager[p].$.onDraw();
                        }
                    }
                }
            }, 500);
        },

        __callViewFunction(funcName,param){
            if(window.container){
                window.parent.postMessage({
                    __private : true,
                    funcName : funcName,
                    param:param
                },'*')
            }
        },

        onKeyDown(e){
            
            if(e.code == "ShiftLeft"){
                //用于放大缩小改变鼠标样式
                for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        if(!this.$store.state.system.$.indexDB[0].isSvg){
                            this.$store.state.system.manager[p].$.$refs.canvasNode.classList.add("enlargeStyle");
                        }else{
                            this.$store.state.system.manager[p].$.$refs.svgNode.classList.add("enlargeStyle");
                        }
                        
                    }
                }
            }
            if(e.altKey && e.ctrlKey && e.keyCode == 80){
                if(this.jsonSysRootConfig.isShowMenu == undefined){
                    this.jsonSysRootConfig.isShowMenu = true;
                }
                this.jsonSysRootConfig.isShowMenu = this.jsonSysRootConfig.isShowMenu ? false : true;
                this.__callViewFunction("showMenu",[this.jsonSysRootConfig.isShowMenu]);
            }
            if(e.ctrlKey){
                switch(e.keyCode){
                    case 79://o
                        this.__callViewFunction("openOpenWindow",[]);
                    break;
                    case 73://i
                        this.__callViewFunction("showSeting",[]);
                    break;
                    case 81://q
                        this.__callViewFunction("Exit",[]);
                    break;
                }
            }
            //设置 放大缩小组建显隐
            var keyCode = e.keyCode || e.which || e.charCode;
            var ctrlKey = e.ctrlKey || e.metaKey;
            if(ctrlKey && keyCode == 81) {
                var open = !this.$store.state.system.dragResize.$.isdisplay;
                this.$store.state.system.dragResize.$.isdisplay = !this.$store.state.system.dragResize.$.isdisplay;
            }
        },

        onKeyUp(e){
            if(e.shiftKey == false){
                this.animationType = true;
            }
            //用于放大缩小改变鼠标样式
            if(e.code == "ShiftLeft"){
                for(let p in this.$store.state.system.manager){
                    if(p != "$"){
                        if(!this.$store.state.system.$.indexDB[0].isSvg){
                            this.$store.state.system.manager[p].$.$refs.canvasNode.classList.remove("enlargeStyle");
                        }else{
                            this.$store.state.system.manager[p].$.$refs.svgNode.classList.remove("enlargeStyle");
                        }
                        
                    }
                }
            }
            
            
        }
    }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  width: 100%;
}
/**
*放大状态
*/
.enlargeStyle:hover {
    cursor: all-scroll !important;
}
/**
拖动状态
*/
.supportStyle:hover {
    cursor: -webkit-grabbing !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue